import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import ContentMessage from '../../_lib/components/ContentMessage/ContentMessage';
import { ContactPerson } from '../../_lib/components/ContactPerson/ContactPerson';
import { ContentList, ContentListItem } from '../../_lib/components/ContentList';
import { FooterLink } from '../../components/molecules/FooterLink/FooterLink';
import IUrl from '../../types/IUrl';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

type BlogAuthorsProps = {
  authors?: ContactPerson[];
  footerLink?: IUrl;
};

/**
 * Lists metadata about a blog.
 * This includes all authors of this blog.
 */
function BlogAuthors({ authors, footerLink }: BlogAuthorsProps) {
  const { t } = useTranslation('Blogs');

  if (authors && authors.length > 0) {
    // author is effectively a contact person without roles
    return (
      <>
        <ContentList ordered>
          {authors.map(author => (
            <ContentListItem key={author.id}>
              <ContactPerson {...author} />
            </ContentListItem>
          ))}
        </ContentList>
        {footerLink && <FooterLink footerButtonLabel={t('authors.blogAuthorsFooterbutton')} footerLink={footerLink} />}
      </>
    );
  }
  // we return a message, if this blog has no authors
  return <ContentMessage text={t('authors.noAuthor')} />;
}

export const BlogAuthorsBlock = asBlock(BlogAuthors, BlockType.blogauthors);
export type BlogAuthorsBlock = ComponentProps<typeof BlogAuthorsBlock>;
